import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';

function ReturnModal({ isOpen, onClose, isLoading, onReturn }) {
  const t = useTranslations();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('user.return_order_key')}
      maxWidth='lg:max-w-[630px] max-sm:max-w-11/12 max-md:max-w-[450px] max-lg:max-w-[500px]'
      headerTitleClassName='pt-[13px] pb-[15px] max-sm:px-[15px] max-md:px-[25px] max-lg:px-[31px] lg:px-[37px]'
      titleClassName='!font-bold text-xl max-sm:text-base max-lg:text-lg'
      closeClassName='max-sm:size-5 max-md:size-6'
    >
      <p className='py-8 text-center font-semibold max-lg:py-6 max-lg:text-base max-md:py-3.5 max-md:text-sm max-sm:py-2.5 max-sm:text-xs lg:text-lg'>
        {t('user.return_order_msg_key')}
      </p>

      <div className='max-lg:8.5 mb-10 max-lg:px-[31px] max-md:mb-6.5 max-md:px-[25px] max-sm:mb-5.5 max-sm:px-[15px] lg:px-[37px]'>
        <Button
          className='w-full max-md:text-sm'
          onClick={onReturn}
          disabled={isLoading}
        >
          {t('user.return_key')}
          {isLoading && <Spinner />}
        </Button>
      </div>
    </Modal>
  );
}

export default ReturnModal;
